import { Divider, DividerProps, styled } from '@mui/material';

export type DividerFadedProps = DividerProps;

export const DividerFaded = styled(Divider)(({ theme }) => ({
  opacity: theme.palette.action.disabledOpacity,
}));
